import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { chooseOptionsConstant, ScreencontrolStateOptionsConstant, templatesOptionsConstant } from 'src/app/constants/service.constants';

import { Subject } from 'rxjs';
import { SCREEN_CONTROL, ControlStateSource, SCREEN_CONTROL_CONDITONS, dropdownsource, Control_Dependents, Control_Dependents_Details, Mapped_Control_Details } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import * as $ from 'jquery';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import * as _ from 'lodash';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-configure-controls-add',
  templateUrl: './configure-controls-add.component.html',
  styleUrls: ['./configure-controls-add.component.scss']
})
export class ConfigureControlsAddComponent implements OnInit {
  @Input() public Content: any;
  chooseOptions = chooseOptionsConstant;
  FieldCondtionsRequired: boolean = false;
  ConditionsList: SCREEN_CONTROL_CONDITONS[] = [];
  controlTypeOptions = [
    { label: "Select", value: 0, checked: true },
    { label: "Alpha numeric Text", value: 1 },
    { label: "Alphabet Text", value: 2 },
    { label: "Number", value: 3 },
    { label: "Single select dropdown", value: 4 },
    { label: "Multi-select dropdown", value: 10 },
    { label: "Date", value: 5 },
    { label: "Checkbox", value: 6 },
    { label: "Radio Buttons", value: 7 },
    { label: "Label", value: 9 },
    { label: "Upload", value: 8 },
    { label: "Text area", value: 11 },
  ];
  DateFormatOptions = [
    { label: "Select", value: 0, checked: true },
    { label: "DD-MMM-YYYY", value: "DD-MMM-YYYY" },
    { label: "MMM-YYYY", value: "MMM-YYYY" },
    { label: "YYYY", value: "YYYY" },
  ]
  controlStateOptions = ScreencontrolStateOptionsConstant;
  rowData: any[];
  FlexyFields: any = [];
  content: any;
  heading: string;
  operation: string;
  rowDataNew: SCREEN_CONTROL = new SCREEN_CONTROL();
  action: Subject<any> = new Subject();
  frameworkComponents;
  context;
  readonly: boolean = false;
  screenid: string = "";
  CONDTIONSLIST: dropdownsource[] = [
    { "label": "Select", "value": "0", Checked: true },
    { "label": "Display", "value": "1", Checked: false },
    { "label": "Enable", "value": "2", Checked: false },
    { "label": "Hide", "value": "3", Checked: false },
    { "label": "Disable", "value": "4", Checked: false }
  ];

  statesource: ControlStateSource[] = [{ "label": "Yes", "value": true }, { "label": "No", "value": false }];
  IsShowMaxLimitBox = false;
  IsShowMandatoryCheck = false;
  IsShowOption = false;
  IsShowDateFormat = false;
  IsShowupload = false;
  IsShowDropdown = false;
  IsShowMultiValues = false;
  IsShowSingleValue = false;
  MaxLength: number = 99;
  OptionValues: any = [];
  IsAllFieldsEditable: boolean = false;
  IsNameEditale: boolean = false;
  ConditionOptionValues: any = [];
  constructor(public modalRef: NgbActiveModal,
    private commonService: CommonService,
    private modalService: NgbModal,
    private summaryService: AdministrationSummaryService, private cdr: ChangeDetectorRef) { }

  addControls = new UntypedFormGroup({
    ID: new UntypedFormControl(""),
    LABEL: new UntypedFormControl(null),
    SCREEN_ID: new UntypedFormControl(this.screenid),
    CONTROL: new UntypedFormControl(0),
    IS_MANDATORY: new UntypedFormControl(false),
    GROUP_VALUES: new UntypedFormControl(null),
    STATE: new UntypedFormControl(1),
    SERIAL_NO: new UntypedFormControl(1),
    PURPOSE: new UntypedFormControl(null),
    ISALLOWMULTIPLEFILES: new UntypedFormControl(false),
    SUBFIELDNAME: new UntypedFormControl(null),
    DATEFORMATE: new UntypedFormControl(null),
    IsActive: new UntypedFormControl(true),
    MAXCHARACTERLENGTH: new UntypedFormControl(null),
    IS_ADMIN_CONFIG: new UntypedFormControl(false),
  })

  ngOnInit() {
    this.FlexyFields = _.cloneDeep(this.Content.FlexyFields);
    this.rowData = _.cloneDeep(this.Content.rowData);
    this.readonly = false;
    if (this.Content.content != null) {
      this.operation = _.cloneDeep(this.Content.content.operation);
      this.screenid = this.Content.content.id;
      if (this.Content.heading == 'Edit') {
        if (this.Content.content.Data.IS_STATIC == false) {
          this.FieldCondtionsRequired = true;
        }
        else {
          this.FieldCondtionsRequired = false;
        }
        this.IsAllFieldsEditable = this.Content.content.Data.IS_EDITABLE;
        this.IsNameEditale = this.Content.content.Data.IS_NAME_EDITABLE;
        if (this.IsAllFieldsEditable == true && this.IsNameEditale == true) {
          this.addControls.enable();
        }
        if (this.IsNameEditale == true) {
          this.addControls.controls["LABEL"].enable();
        }
        else {
          this.addControls.controls["LABEL"].disable();
        }
        this.addControls.patchValue(this.Content.content.Data);
        if (this.Content.content.Data.IS_STATIC) {
          this.addControls.controls['IsActive'].disable();
          //this.addControls.controls["PURPOSE"].disable();
        }
        var obj = { value: this.Content.content.Data.CONTROL }
        this.changeControlType(obj, 'Y');
        this.addControls.controls['CONTROL'].disable();
        this.addControls.controls['MAXCHARACTERLENGTH'].disable();
        this.addControls.controls['DATEFORMATE'].disable();
        this.OptionValues = [];
        this.ConditionOptionValues = [];
        if (this.Content.content.Data.GROUP_VALUES_LIST != "" && this.Content.content.Data.GROUP_VALUES_LIST != null && this.Content.content.Data.GROUP_VALUES_LIST != undefined) {
          this.OptionValues = _.cloneDeep(this.Content.content.Data.GROUP_VALUES_LIST);
          this.ConditionOptionValues = this.OptionValues;
        }
        if (this.Content.content.Data.Control_Condtions != "" && this.Content.content.Data.Control_Condtions != null && this.Content.content.Data.Control_Condtions != undefined) {
          this.ConditionsList = [];
          //this.Content.content.Data.Control_Condtions.forEach((parent) => {
          //  parent.ConditionsList.forEach((child) => {
          //    child.Mapped_Controls_List.forEach((subchild) => {
          //      let objCondition: SCREEN_CONTROL_CONDITONS = {
          //        ID: subchild.ID,
          //        OptionValue: parent.Mapped_Control_Value ?? "",
          //        Condtion: child.Mapped_Condtion ?? "",
          //        MappedFields: child.Mapped_Controls_List.map(item => {
          //          return item.ControlID;
          //        }),
          //        conditionsList: this.CONDTIONSLIST ?? [],
          //        mappedFieldsList: _.cloneDeep(this.FlexyFields) ?? [],
          //        state: 'edit',
          //      };
          //      this.ConditionsList.push(objCondition);
          //    });
          //  });
          //});


          this.Content.content.Data.Control_Condtions.forEach((parent) => {
            parent.ConditionsList.forEach((child) => {
              let objCondition: SCREEN_CONTROL_CONDITONS = {
                ID: parent.ID,
                OptionValue: parent.Mapped_Control_Value ?? "",
                Condtion: child.Mapped_Condtion ?? "",
                MappedFields: child.Mapped_Controls_List.map(item => {
                  return item.ControlID;
                }),
                conditionsList: this.CONDTIONSLIST ?? [],
                mappedFieldsList: _.cloneDeep(this.FlexyFields) ?? [],
                state: 'edit',
              };
              this.ConditionsList.push(objCondition);
            });
          });

        }
        else {
          this.AddCondtion();
        }
        this.OnEditMappedFieledChange(null);
        this.conditionChangeOnEdit();
      }
      else if (this.Content.heading == "Add") {
        this.FieldCondtionsRequired = true;
        this.AddCondtion();
      }
    }
    this.Content.heading = this.Content.heading;
  }
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.addControls.getRawValue();
    if (formData.LABEL == null || formData.LABEL == "" || formData.LABEL == undefined) {
      $("#LABEL").addClass("ng-touched ng-invalid validate-error");
      $("#LABEL").removeClass("ng-untouched ng-valid");
      message += "Please enter Field Name<br/>";
      isValid = false;
    } else if (formData.LABEL != null && formData.LABEL != undefined && formData.LABEL.trim() == "") {
      $("#LABEL").addClass("ng-touched ng-invalid validate-error");
      $("#LABEL").removeClass("ng-untouched ng-valid");
      message += "Please enter Field Name<br/>";
      isValid = false;
    }
    else {
      $("#LABEL").addClass("ng-untouched ng-valid");
      $("#LABEL").removeClass("ng-touched ng-invalid validate-error");
    }
    if (formData.CONTROL == null || formData.CONTROL == "0" || formData.CONTROL == "") {
      $("#CONTROL").addClass("ng-touched ng-invalid validate-error");
      $("#CONTROL").removeClass("ng-untouched ng-valid");
      message += "Please select Field Type<br/>";
      isValid = false;
    } else {
      $("#CONTROL").addClass("ng-untouched ng-valid");
      $("#CONTROL").removeClass("ng-touched ng-invalid validate-error");
    }
    if (formData.CONTROL == 1 || formData.CONTROL == 2 || formData.CONTROL == 3) {
      if (formData.MAXCHARACTERLENGTH === null || formData.MAXCHARACTERLENGTH === "") {
        $("#MAXCHARACTERLENGTH").addClass("ng-touched ng-invalid validate-error");
        $("#MAXCHARACTERLENGTH").removeClass("ng-untouched ng-valid");
        message += "Please enter Maximum characters Limit<br/>";
        isValid = false;
      } else {
        $("#MAXCHARACTERLENGTH").addClass("ng-untouched ng-valid");
        $("#MAXCHARACTERLENGTH").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    if (!this.addControls.controls["IS_ADMIN_CONFIG"].value) {
      if (formData.CONTROL == 4 || formData.CONTROL == 10) {
        let isValidate = false;
        let givenlabels = [];
        if (this.OptionValues != null && this.OptionValues != undefined && this.OptionValues.length == 0) {
          message += "Please enter at least one Value<br/>";
          isValid = false;
        } else {

          this.OptionValues.forEach((item) => {
            if ((item.label == "" || item.label == null || item.label == undefined || !item.label.trim()) && !isValidate) {
              isValidate = true;
              message += "Please enter Value(s)<br/>";
              isValid = false;
            }
            else {
              let Label: string = item.label;
              if (givenlabels.indexOf(Label.toLowerCase()) > -1 && !isValidate) {
                isValidate = true;
                message += "Please enter unique Value(s)<br/>";
                isValid = false;
              }
              else {
                givenlabels.push(Label.toLowerCase());
              }
            }
          })
        }
        let isInvalidCondition = false;
        this.ConditionsList.forEach((item) => {
          if ((!item.OptionValue && item.Condtion == "0" && item.MappedFields.length == 0) || (item.OptionValue && item.Condtion != "0" && item.MappedFields.length > 0)) {
            //
          }
          else {
            isValid = false;
            isInvalidCondition = true;
          }
        });

        //debugger;
        //let inValidCondition = this.ConditionsList.filter(x => (!x.OptionValue && x.Condtion == "0" && x.MappedFields.length == 0) || (x.OptionValue && x.Condtion != "0" && x.MappedFields.length > 0));
        //if (this.ConditionsList.length != inValidCondition.length) {
        //  isValid = false;
        //  isInvalidCondition = true;
        //}

        if (isInvalidCondition) {
          message += "Please select Conditions value(s)<br/>";
        }
      }
      if (formData.CONTROL == 7 || formData.CONTROL == 6) {
        let givenData = [];
        let isValidate = false;
        this.OptionValues.forEach((item) => {
          if ((item.label == "" || item.label == null || item.label == undefined) && !isValidate) {
            isValidate = true;
            if (formData.CONTROL == 6) {
              message += "Please enter Text(s)<br/>";
              isValid = false;
            }
            else {
              message += "Please enter Value(s)<br/>";
              isValid = false;
            }
          }
          else {
            if (givenData.indexOf(item.label.toLowerCase()) > -1 && !isValidate) {
              isValidate = true;
              if (formData.CONTROL == 6) {
                message += "Please enter unique Text(s)<br/>";
                isValid = false;
              }
              else {
                message += "Please enter unique Value(s)<br/>";
                isValid = false;
              }

            }
            else {
              givenData.push(item.label.toLowerCase());
              // isValidate=true;
              // message += "Please enter unique Value(s)<br/>";
              //   isValid = false;
            }
          }
        });
      }
    }

    if (formData.CONTROL == 5) {
      if (formData.DATEFORMATE === null || formData.DATEFORMATE === "") {
        $("#DATEFORMATE").addClass("ng-touched ng-invalid validate-error");
        $("#DATEFORMATE").removeClass("ng-untouched ng-valid");
        message += "Please select Date format<br/>";
        isValid = false;
      } else {
        $("#DATEFORMATE").addClass("ng-untouched ng-valid");
        $("#DATEFORMATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    if (formData.CONTROL == 8) {
      if (formData.SUBFIELDNAME === null || formData.SUBFIELDNAME === "") {
        $("#SUBFIELDNAME").addClass("ng-touched ng-invalid validate-error");
        $("#SUBFIELDNAME").removeClass("ng-untouched ng-valid");
        message += "Please enter Name<br/>";
        isValid = false;
      } else {
        $("#SUBFIELDNAME").addClass("ng-untouched ng-valid");
        $("#SUBFIELDNAME").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    if (formData.CONTROL == 9) {
      if (formData.SUBFIELDNAME === null || formData.SUBFIELDNAME.trim() === "" || formData.SUBFIELDNAME === undefined) {
        $("#SUBFIELDNAME").addClass("ng-touched ng-invalid validate-error");
        $("#SUBFIELDNAME").removeClass("ng-untouched ng-valid");
        message += "Please enter Label Text<br/>";
        isValid = false;
      } else {
        $("#SUBFIELDNAME").addClass("ng-untouched ng-valid");
        $("#SUBFIELDNAME").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    if (!isValid)
      //this.cdr.detectChanges();
      this.commonService.ValidationBanner(message);
    //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    return isValid;
  }
  addcontrol(): any {
    if (this.validateControls()) {
      this.rowDataNew.STATE = 1;
      this.rowDataNew.STATEVALUE = this.addControls.controls["IsActive"].value == true ? "Active" : "Inactive";
      this.rowDataNew.CONTROL = this.addControls.controls["CONTROL"].value;
      if (this.Content.heading == "Edit") {
        this.rowDataNew.ID = this.addControls.controls["ID"].value;
      }
      else {
        this.rowDataNew.ID = this.commonService.getUniqueId();
      }
      this.rowDataNew.IS_MANDATORY = this.addControls.controls["IS_MANDATORY"].value;
      this.rowDataNew.IS_MANDATORYStr = this.rowDataNew.IS_MANDATORY == true ? "Yes" : "No";
      this.rowDataNew.CONTROLTYPE = this.getcontroltype(this.addControls.controls["CONTROL"].value);
      this.rowDataNew.SERIAL_NO = 1;
      this.rowDataNew.SCREEN_ID = this.screenid;
      this.rowDataNew.ISALLOWMULTIPLEFILES = this.addControls.controls["ISALLOWMULTIPLEFILES"].value;
      this.rowDataNew.DATEFORMATE = this.addControls.controls["DATEFORMATE"].value;

      let groupValues = _.cloneDeep(this.OptionValues);
      if (groupValues != null && groupValues != undefined && groupValues.length) {
        let str = [];
        groupValues.forEach((item) => {
          str.push(item.label);
        });
        this.rowDataNew.GROUP_VALUES_LIST = _.cloneDeep(groupValues);
        this.rowDataNew.GROUP_VALUES = str.join(",");
      }
      else {
        this.rowDataNew.GROUP_VALUES = "";
        this.rowDataNew.GROUP_VALUES_LIST = [];

      }

      //24R2 FIELD CONDITIONS CHANGES START
      //#region 24R2 FIELD CONDITIONS CHANGES
      let conditionInfo: Control_Dependents[] = [];
      let str = [];
      if (this.ConditionsList && this.ConditionsList.length > 0) {
        this.ConditionsList.forEach((item) => {
          if (item && item.Condtion && item.Condtion != "0") {

            if (item.MappedFields && item.MappedFields.length > 0) {
              item.MappedFields.forEach((ci) => {
                if (ci && !str.includes(ci)) {
                  str.push(ci);
                }
              })
            }

            let conditions: Control_Dependents_Details[] = [];
            let mappedFiledsList: Mapped_Control_Details[] = [];
            if (item.MappedFields && item.MappedFields.length > 0) {
              mappedFiledsList = item.MappedFields.map((mapItem) => {
                let res: Mapped_Control_Details = {
                  ControlID: mapItem,
                  Control_Field_Code: "",
                  Control_Type: "",
                }
                return res;
              });
            }

            let controlDependency: Control_Dependents_Details = {
              Mapped_Condtion: item.Condtion ?? "",
              Mapped_Controls_List: mappedFiledsList ?? [],
            }
            conditions.push(controlDependency);

            let info: Control_Dependents = {
              ID: item.ID,
              ControlID: item.ID,
              Control_Field_Code: "",
              Control_label: "",
              Control_Type: "",
              Mapped_Control_Value: item.OptionValue,
              ConditionsList: conditions,
              state: item.state
            };
            conditionInfo.push(info);
          }
        });
      }

      this.rowDataNew.FILED_VALUES = str.length > 0 ? str.join(",") : "";
      this.rowDataNew.Control_Condtions = conditionInfo;
      //#endregion 24R2 FIELD CONDITIONS CHANGES
      //24R2 FIELD CONDITIONS CHANGES END

      this.rowDataNew.IS_STATIC = false;
      this.rowDataNew.IS_DISPLAY = 1;
      this.rowDataNew.IS_EDITABLE = true;
      this.rowDataNew.LABEL = this.addControls.controls["LABEL"].value;
      this.rowDataNew.SUBFIELDNAME = this.addControls.controls["SUBFIELDNAME"].value;
      this.rowDataNew.LABEL = this.addControls.controls["LABEL"].value;
      this.rowDataNew.DATEFORMATE = this.addControls.controls["DATEFORMATE"].value;
      this.rowDataNew.IsActive = this.addControls.controls["IsActive"].value;
      this.rowDataNew.MAXCHARACTERLENGTH = this.addControls.controls["MAXCHARACTERLENGTH"].value == "" ? 0 : this.addControls.controls["MAXCHARACTERLENGTH"].value;
      this.rowDataNew.PURPOSE = this.addControls.controls["PURPOSE"].value;
      let IsValid = true;
      let message = "";
      if (this.operation == "Add") {
        this.rowDataNew.ROWSTATE = "Add";
        this.rowDataNew.LABEL = this.rowDataNew.LABEL == null ? null : this.rowDataNew.LABEL == undefined ? undefined : this.rowDataNew.LABEL.trim();
        this.Content.rowData.forEach((element) => {
          if (element.LABEL.trim().toLowerCase() == this.rowDataNew.LABEL.trim().toLowerCase() && IsValid) {
            IsValid = false;
            message = "Field with '" + this.rowDataNew.LABEL + "' already exists. Please enter unique field name";
          }
        });
      }
      else {
        this.rowDataNew.ROWSTATE = "Edit";
        this.rowDataNew.LABEL = this.rowDataNew.LABEL == null ? null : this.rowDataNew.LABEL == undefined ? undefined : this.rowDataNew.LABEL.trim();
        this.Content.rowData.forEach((element) => {
          if (element.LABEL.toLowerCase() == this.rowDataNew.LABEL.trim().toLowerCase() && element.ID != this.rowDataNew.ID && IsValid) {
            IsValid = false;
            message = "Please enter unique Field name";
          }
        });
      }
      if (IsValid) {
        // if (this.operation == "Add") {
        // this.commonService.SuccessBanner("Field "+this.rowDataNew.LABEL+" added successfully");
        // }
        // else{
        //   this.commonService.SuccessBanner("Field "+this.rowDataNew.LABEL+" updated successfully");
        // }
        // this.action.next(this.rowDataNew);
        this.modalRef.close(this.rowDataNew);
      }
      else {
        this.commonService.ValidationBanner(message);
        // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
      }

    }
    // }

  }

  getcontroltype(ctype: any): string {
    ctype = parseInt(ctype);
    var controltype = "";

    switch (ctype) {
      case 1:
        controltype = "Alpha numeric Text";
        break;
      case 2:
        controltype = "Alphabet Text";
        break;
      case 3:
        controltype = "Number ";
        break;
      case 4:
        controltype = "Single select dropdown";
        break;
      case 5:
        controltype = "Date";
        break;
      case 6:
        controltype = "Checkbox";
        break;
      case 7:
        controltype = "Radio Buttons";
        break;
      case 8:
        controltype = "Upload";

        break;
      case 9:
        controltype = "Label";
        break;
      case 10:
        controltype = "Multi-select dropdown";
        break;
      default:

        break;
    }


    return controltype;
  }

  changeControlType(event: any, isSkip = '') {
    this.OptionValues = [];
    this.IsShowMaxLimitBox = false;
    this.IsShowMandatoryCheck = false;
    this.IsShowOption = false;
    this.IsShowDateFormat = false;
    this.IsShowupload = false;
    this.IsShowDropdown = false;
    this.IsShowMultiValues = false;
    this.IsShowSingleValue = false;
    if (isSkip != 'Y') {
      this.addControls.controls["MAXCHARACTERLENGTH"].setValue('');
      this.addControls.controls["SUBFIELDNAME"].setValue('');
    }
    switch (event.value) {
      case 1:
        this.IsShowMaxLimitBox = true;
        this.IsShowMandatoryCheck = true;
        this.MaxLength = 99;
        break;
      case 2:
        this.IsShowMaxLimitBox = true;
        this.IsShowMandatoryCheck = true;
        this.MaxLength = 99;
        break;
      case 3:
        this.IsShowMaxLimitBox = true;
        this.IsShowMandatoryCheck = true;
        this.MaxLength = 4;
        break;
      case 4:
        this.IsShowOption = true;
        this.IsShowDropdown = true;
        this.IsShowMandatoryCheck = true;
        break;
      case 5:
        this.IsShowMandatoryCheck = true;
        this.IsShowDateFormat = true;

        break;
      case 6:
        this.IsShowMandatoryCheck = true;
        this.IsShowOption = true;
        this.IsShowMultiValues = true;
        this.OptionValues.push({ value: this.commonService.getUniqueId(), label: "", RECORD_STATE: 1 });

        break;
      case 7:
        this.IsShowMandatoryCheck = true;
        this.IsShowOption = true;
        this.IsShowMultiValues = true;
        this.OptionValues.push({ value: this.commonService.getUniqueId(), label: "", RECORD_STATE: 1 });
        this.OptionValues.push({ value: this.commonService.getUniqueId(), label: "", RECORD_STATE: 1 });
        break;
      case 8:
        this.IsShowMandatoryCheck = true;
        this.IsShowupload = true;
        this.IsShowSingleValue = true;
        break;
      case 9:
        this.IsShowSingleValue = true;
        break;
      case 10:
        this.IsShowMandatoryCheck = true;
        this.IsShowOption = true;
        this.IsShowDropdown = true;
        break;
      case 11:
        this.IsShowMaxLimitBox = true;
        this.IsShowMandatoryCheck = true;
        this.MaxLength = 99;
        break;
    }
  }

  markDirty(evet) {
    this.addControls.markAsDirty();
  }
  AddValues() {
    if (!this.addControls.controls["IS_ADMIN_CONFIG"].value) {
      this.addControls.markAsDirty();
      if (this.addControls.controls['CONTROL'].value == 6 || this.addControls.controls['CONTROL'].value == 7) {
        if (this.OptionValues.length < 15) {
          this.OptionValues.push({ value: this.commonService.getUniqueId(), label: "", RECORD_STATE: 1 });
          $("#PLUSICON").removeClass("disbleplus");
        }
        else
          $("#PLUSICON").addClass("disbleplus");

      }
      if (this.addControls.controls['CONTROL'].value == 4 || this.addControls.controls['CONTROL'].value == 10) {
        if (this.OptionValues.length < 50) {
          this.OptionValues.push({ value: this.commonService.getUniqueId(), label: "", RECORD_STATE: 1 });
          $("#PLUSICON").removeClass("disbleplus");
        }
        else
          $("#PLUSICON").addClass("disbleplus");

      }
      this.ConditionOptionValues = this.OptionValues;
    }
  }

  RemoveValue(child) {
    this.addControls.markAsDirty();
    if (this.operation != "Add") {
      const modalRef = this.modalService.open(DeleteBoxComponent, {
        backdrop: false
      })
      modalRef.componentInstance.Content = { heading: 'Delete', custommessage: 'Are you sure you want to delete ' + "'" + child.label + "'" + ' ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" }
      modalRef.result.then(result => {
        if (result == "okclick") {
          let isValUsed = this.checkValueUsedInCondition(child);
          if (!isValUsed) {
            this.commonService.ValidationBanner("this value cannot be deleted as it has a condition configured");
          }
          else {
            this.summaryService.checkControlValueReference(this.addControls.controls["ID"].value, child.value).subscribe((result) => {
              if (result) {
                this.commonService.ValidationBanner("You cannot delete this as it is associated to an application");
              }
              else {
                this.OptionValues.forEach((item, index) => {
                  if (item.value == child.value) {
                    this.OptionValues.splice(index, 1);
                    $("#PLUSICON").removeClass("disbleplus");
                  }
                });

                //this.ConditionOptionValues = _.cloneDeep(this.OptionValues);
                //let tempList = _.cloneDeep(this.ConditionsList);
                //this.ConditionsList.forEach((item) => {
                //  if (item.OptionValue == child.value) {
                //    let removeIndex = tempList.findIndex(x => x.ID == item.ID);
                //    if (removeIndex != -1) {
                //      tempList.splice(removeIndex, 1);
                //    }
                //  }
                //});
                //this.ConditionsList = _.cloneDeep(tempList);
              }
            });
          }
        }
      });
    }
    else {

      let isValUsed = this.checkValueUsedInCondition(child);
      if (!isValUsed) {
        this.commonService.ValidationBanner("this value cannot be deleted as it has a condition configured");
      }
      else {
        this.OptionValues.forEach((item, index) => {
          if (item.value == child.value) {
            this.OptionValues.splice(index, 1);
            $("#PLUSICON").removeClass("disbleplus");
          }
        });
        //this.ConditionOptionValues = _.cloneDeep(this.OptionValues);
        //let tempList = _.cloneDeep(this.ConditionsList);
        //this.ConditionsList.forEach((item) => {
        //  if (item.OptionValue == child.value) {
        //    let removeIndex = tempList.findIndex(x => x.ID == item.ID);
        //    if (removeIndex != -1) {
        //      tempList.splice(removeIndex, 1);
        //    }
        //  }
        //});
        //this.ConditionsList = _.cloneDeep(tempList);
      }
    }

  }

  checkValueUsedInCondition(data) {
    let canDelete: boolean = false;
    if (data && data.value) {
      let valueIndex = this.ConditionsList.findIndex(x => x.OptionValue == data.value);
      if (valueIndex == -1) {
        canDelete = true;
      }
    }
    return canDelete;
  }

  AddCondtion() {
    if (this.ConditionsList.length == 0)
      this.ConditionsList.push({ ID: this.commonService.getUniqueId(), OptionValue: "", Condtion: "0", MappedFields: [], state: "add", conditionsList: this.CONDTIONSLIST, mappedFieldsList: this.FlexyFields });
    else {
      let isValid = true;
      this.ConditionsList.forEach((item) => {
        if ((item.OptionValue == "" || item.Condtion == "0" || item.MappedFields.length == 0) && item.state != "delete") {
          isValid = false;
        }

      });
      if (isValid) {

        this.ConditionsList.push({ ID: this.commonService.getUniqueId(), OptionValue: "", Condtion: "0", MappedFields: [], state: "add", conditionsList: this.CONDTIONSLIST, mappedFieldsList: this.FlexyFields });

      }
      else {
        this.commonService.ValidationBanner("Please fill required Data");
      }
    }
  }
  optionValueChange(con: any, evnt: any) {

    //if (this.Content.heading == 'Add') {
    //24R2 FIELD CONDITION CHANGES START
    //#region 24R2 FIELD CONDITION CHANGES START
    let TempMappedFieldsList = [];
    let str = "";
    this.ConditionsList.forEach((item) => {
      if (item.ID == con.ID) {
        item.conditionsList = [];
        item.Condtion = "0";
        item.OptionValue = evnt.value;
        item.MappedFields = [];
        item.mappedFieldsList = [];
      }
      else {
        str = str + "," + item.MappedFields.join(",");
      }
    });
    TempMappedFieldsList = this.FlexyFields.filter(item => str.indexOf(item.ID) == -1);
    //#endregion 24R2 FIELD CONDITION CHANGES END
    //24R2 FIELD CONDITION CHANGES END
    let TempConditionsList = [];
    var Displ = this.ConditionsList.filter((rec) => {
      return rec.Condtion == "1" && rec.OptionValue == con.OptionValue
    })[0];
    if (Displ == undefined || Displ == null) {
      TempConditionsList.push({ "label": "Display", "value": "1", Checked: false })
    }
    var Enable = this.ConditionsList.filter((rec) => {
      return rec.Condtion == "2" && rec.OptionValue == con.OptionValue
    })[0];
    if (Enable == undefined || Enable == null) {
      TempConditionsList.push({ "label": "Enable", "value": "2", Checked: false })
    }

    var Hide = this.ConditionsList.filter((rec) => {
      return rec.Condtion == "3" && rec.OptionValue == con.OptionValue
    })[0];
    if (Hide == undefined || Hide == null) {
      TempConditionsList.push({ "label": "Hide", "value": "3", Checked: false })
    }

    var Disable = this.ConditionsList.filter((rec) => {
      return rec.Condtion == "4" && rec.OptionValue == con.OptionValue
    })[0];
    if (Disable == undefined || Disable == null) {
      TempConditionsList.push({ "label": "Disable", "value": "4", Checked: false })
    }

    //24R2 FIELD CONDITION CHANGES START
    //#region 24R2 FIELD CONDITION CHANGES START
    this.ConditionsList.forEach((item) => {
      if (item.ID == con.ID) {
        item.conditionsList = TempConditionsList;
        item.mappedFieldsList = TempMappedFieldsList;
      }

    });
    //#endregion 24R2 FIELD CONDITION CHANGES END
    //24R2 FIELD CONDITION CHANGES END
    //}
    //else {
    //  this.optionValueChangeOnEdit();
    //}


  }

  conditionChangeOnEdit() {
    this.ConditionsList.forEach((item) => {
      let TempConditionsList = [];
      if (item.Condtion == "1") {
        TempConditionsList.push({ "label": "Display", "value": "1", Checked: true });
      }
      else if (item.Condtion == "2") {
        TempConditionsList.push({ "label": "Enable", "value": "2", Checked: true });
      }
      else if (item.Condtion == "3") {
        TempConditionsList.push({ "label": "Hide", "value": "3", Checked: true })
      }
      else if (item.Condtion == "4") {
        TempConditionsList.push({ "label": "Disable", "value": "4", Checked: true })
      }

      let str = "";
      //let otherConditions = this.ConditionsList.map((child) => { return child.Condtion });
      //if (otherConditions != null && otherConditions.length > 0) {
      //  str = otherConditions.join(",");
      //}
      //if (str) {
      //  let templist = this.CONDTIONSLIST.filter(st => str.indexOf(st.value) == -1);
      //  if (templist != null && templist.length > 0) {
      //    templist.forEach((child) => {
      //      if (!TempConditionsList.includes(child)) {
      //        TempConditionsList.push(child);
      //      }
      //    })
      //  }
      //}
      let items = this.ConditionsList.filter((child) => child.OptionValue == item.OptionValue).map((x) => { return x.Condtion });
      //let items = itemOptionValueList.map((child) => { return child.Condtion });
      if (items != null && items.length > 0) {
        str = items.join(",");
      }
      if (str) {
        let templist = this.CONDTIONSLIST.filter(st => str.indexOf(st.value) == -1);
        if (templist != null && templist.length > 0) {
          templist.forEach((child) => {
            if (!TempConditionsList.includes(child)) {
              TempConditionsList.push(child);
            }
          })
        }
      }
      TempConditionsList = TempConditionsList.sort((a, b) => a.value - b.value);
      item.conditionsList = TempConditionsList;
    });
  }

  conditionChange(con: any, evnt: any) {
    if (this.Content.heading == 'Add') {
      this.ConditionsList.forEach((item) => {
        if (item.ID == con.ID) {
          item.Condtion = evnt.value;
        }
      });
    }
    else {
      this.conditionChangeOnEdit();
    }
  }

  mappedFieldChange(con: any, evnt: any) {
    if (this.Content.heading == 'Add') {
      let TempMappedFieldsList = [];
      let str = "";
      this.ConditionsList.forEach((item) => {
        if (item.ID == con.ID) {
          item.MappedFields = evnt.value;
        }
        else {
          str = str + "," + item.MappedFields.join(",");
        }
      });
      TempMappedFieldsList = this.FlexyFields.filter(item => str.indexOf(item.ID) == -1);
      this.ConditionsList.forEach((item) => {
        if (item.ID == con.ID) {
          item.mappedFieldsList = TempMappedFieldsList;
        }
      });
    }
    else {
      this.OnEditMappedFieledChange(con);
    }
  }

  OnEditMappedFieledChange(con) {
    let tempMappedFldList = [];
    this.ConditionsList.forEach((tmf) => {
      if (tmf && tmf.MappedFields.length > 0) {
        tmf.MappedFields.forEach((child) => {
          if (!tempMappedFldList.includes(child)) {
            tempMappedFldList.push(child);
          }
        })
      }
    });
    this.ConditionsList.forEach((parent) => {
      let str = "";
      str = str + tempMappedFldList.join(",");
      let TempMappedFieldsList = this.FlexyFields.filter((item) => {
        return str.indexOf(item.ID) == -1;
      });
      parent.MappedFields.forEach((parentid) => {
        let Temp = this.FlexyFields.filter(x => x.ID == parentid);
        if (Temp) {
          Temp.forEach((tt) => {
            if (!TempMappedFieldsList.includes(tt)) {
              TempMappedFieldsList.push(tt);
            }
          })
        }
      })
      parent.mappedFieldsList = TempMappedFieldsList;
    });
  }

  RemoveCondtion(id: any, indexNum: number) {
    this.ConditionsList.splice(indexNum, 1);
    //this.ConditionsList.forEach((item, index) => {
    //  if (item.ID == id) {
    //    this.ConditionsList.splice(index, 1);
    //  }
    //});
  }


  close() {
    this.canExit().then(x => {
      this.modalRef.dismiss();
    });
  }

  moveInArray(arr, fromIndex, toIndex) {
    this.addControls.markAsDirty();
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  MovePostion(naviType, element) {

    let fromIndex = this.OptionValues.indexOf(element);
    if (naviType == "down") {
      let toIndex = fromIndex + 1;
      this.moveInArray(this.OptionValues, fromIndex, toIndex);
    }
    else {
      let toIndex = fromIndex - 1;
      this.moveInArray(this.OptionValues, fromIndex, toIndex);
    }
  }

  canExit() {
    if (this.addControls.dirty && this.operation != "Add") {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }


  get enableAddCondition() {
    let isValid = false;
    this.ConditionsList.forEach((item) => {
      if ((item.OptionValue == "" || item.Condtion == "0" || (item.MappedFields && item.MappedFields.length == 0)) && item.state != "delete") {
        isValid = true;
      }

    });
    return isValid;
  }


  onActiveChange(child: any, evnt: any) {
    if (evnt.target.checked == true) {
      child.RECORD_STATE = 1;
    }
    else {
      child.RECORD_STATE = 0;
    }
  }

  filedactiveOnChange(filedStatus: any) {
    if (this.Content.heading == 'Edit') {
      if (filedStatus.target.checked == false) {
        if (this.rowData) {
          this.rowData.forEach((item) => {
            item.Control_Condtions.forEach((cond) => {
              cond.ConditionsList.forEach((flds) => {
                if (flds.Mapped_Controls_List && flds.Mapped_Controls_List.length > 0) {
                  let controlId = flds.Mapped_Controls_List.filter((x) => { return x.ControlID == this.Content.content.Data.ID });
                  if (!controlId || controlId.length > 0) {
                    this.addControls.controls['IsActive'].setValue(true);
                    this.commonService.ValidationBanner("You cannot Inactive this field as it is associated to other configuration");
                  }
                }
              })
            });
          });
        }
      }
    }

  }
}


